@use '../../scss/global' as *;
@use '../../scss/components/form-element.mixins' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  .fluid-toggle-group {

    // ==== Shared Form Element Styles

    @include form-group();

    // ==== Form Label

    .toggle-group-label {
      padding-bottom: 0.5em;
    }

    // ==== Toggle Group Layouts

    .horizontal-layout,
    .group-type-chip,
    .group-type-toggle-chip {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }

    .horizontal-layout {
      column-gap: 2em;
    }

    .group-type-chip,
    .group-type-toggle-chip {
      column-gap: 0.75em;
    }

    // ==== Dropdown Menu Toggle Group

    .menu-section {
      position: relative;

      .toggle-all {
        position: sticky;
        top: 0;
        background-color: $white;
        padding-bottom: 0.25em;
        margin-bottom: 0.25em;
        z-index: 2;

        &::after {
          height: 1px;
          display: block;
          position: absolute;
          bottom: 0;
          left: calc(var(--G-menu-item-padding-left) * 0.8);
          right: calc(var(--G-menu-item-padding-right) * 0.8);
          box-shadow: 0 1px 1.5px 0 rgba(0, 0, 0, .15);
          content: "";
        }
      }
    }

    // ==== "Toggle All" Toggle

    .toggle-all {
      --I-font-weight: #{$font-weight-bold}; // Inherited by Toggle
    }
  }
}
